import { useState , useEffect} from 'react';
import axios from 'axios';

export const useFetchHistory = () => {
    const [historyList, setHistoryList] = useState([]);
    const [isLoading , setIsLoading] = useState(false);
    
    useEffect(() => {
        const fetchRequest = async ()  =>{
            setIsLoading(true);

            //JSON取得
            axios.get('/assets/json/historyData.json?'+(new Date()).getTime())
                .then(res => {
                    const data = JSON.parse(JSON.stringify(res.data));
                    setHistoryList(data.list);
                })
                //.catch(() => setIsError(true))
                .finally(() => setIsLoading(false));
        }
        fetchRequest();
    }, []); 

    return {historyList , isLoading };
}
